import cx from 'classnames';
import React from 'react';

export type Props = {
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl';
  className?: string;
  children?: React.ReactNode;
};

export const Avatar = ({ className, size = 'md', children }: Props): JSX.Element => {
  return (
    <div
      className={cx(className, 'text-black-100% font-semibold overflow-hidden rounded-full', {
        'w-24 text-xxs': size === 'sm',
        'w-32 text-sm': size === 'md',
        'w-40 text-md': size === 'lg',
        'w-64 text-md': size === 'xl',
        'w-120 text-md': size === 'xxl',
        'w-[185px] text-md': size === 'xxxl',
        'bg-orange-300': !className || !className.match(/bg-.*/),
      })}
    >
      <div aria-hidden="true" className="aspect-w-1 aspect-h-1">
        <div className="flex items-center justify-center leading-none">{children}</div>
      </div>
    </div>
  );
};
